import AustriaFlagIcon from "./AustriaFlagIcon.vue";
import BelgiumFlagIcon from "./BelgiumFlagIcon.vue";
import GermanyFlagIcon from "./GermanyFlagIcon.vue";
import LuxembourgFlagIcon from "./LuxembourgFlagIcon.vue";
import NetherlandsFlagIcon from "./NetherlandsFlagIcon.vue";
import SwitzerlandFlagIcon from "./SwitzerlandFlagIcon.vue";
import SpainFlagIcon from "./SpainFlagIcon.vue";

export default {
    AustriaFlagIcon,
    BelgiumFlagIcon,
    GermanyFlagIcon,
    LuxembourgFlagIcon,
    NetherlandsFlagIcon,
    SwitzerlandFlagIcon,
    SpainFlagIcon,
};
